package com.devi3east.bashbuddy

import app.cash.sqldelight.SuspendingTransacter
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import com.devi3east.bashbuddy.composeApp.newInstance
import com.devi3east.bashbuddy.composeApp.schema
import kotlin.Unit

public interface BashBuddyLocalDatabase : SuspendingTransacter {
  public val favoriteRecipeQueries: FavoriteRecipeQueries

  public val recipeEntityQueries: RecipeEntityQueries

  public companion object {
    public val Schema: SqlSchema<QueryResult.AsyncValue<Unit>>
      get() = BashBuddyLocalDatabase::class.schema

    public operator fun invoke(driver: SqlDriver, RecipeAdapter: Recipe.Adapter):
        BashBuddyLocalDatabase = BashBuddyLocalDatabase::class.newInstance(driver, RecipeAdapter)
  }
}
